var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.5,
    height: 32,
    viewBox: "0 0 33.5 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-coffee",
    "data-name": "Icon feather-coffee",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_132",
    "data-name": "Trac\\xE9 132",
    d: "M27,12h1.5a6,6,0,0,1,0,12H27",
    transform: "translate(-3 -1.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_133",
    "data-name": "Trac\\xE9 133",
    d: "M3,12H27V25.5a6,6,0,0,1-6,6H9a6,6,0,0,1-6-6Z",
    transform: "translate(-3 -1.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_134",
    "data-name": "Trac\\xE9 134",
    d: "M9,1.5V6",
    transform: "translate(-3 -1.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_135",
    "data-name": "Trac\\xE9 135",
    d: "M15,1.5V6",
    transform: "translate(-3 -1.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_136",
    "data-name": "Trac\\xE9 136",
    d: "M21,1.5V6",
    transform: "translate(-3 -1.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoffee);
export default __webpack_public_path__ + "static/media/icon-coffee.79f831cc464ed99372d1b57dc549e1fc.svg";
export { ForwardRef as ReactComponent };